import React from 'react';
import { Box, CircularProgress, Stack, Typography } from '@mui/joy';
import { motion, AnimatePresence } from 'framer-motion';
import FunctionCard from './FunctionCard';

const FunctionsGrid = ({
  functions,
  loading,
  getFunctionStatus,
  isRunning,
  selectedFunctionId,
  onRun,
  onEdit,
  onDuplicate,
  onDelete,
  onViewLogs,
  onSelect,
}) => {
  if (loading && functions.length === 0) {
    return (
      <Stack alignItems="center" justifyContent="center" sx={{ py: 8 }}>
        <CircularProgress size="lg" />
        <Typography level="body-sm" color="neutral" sx={{ mt: 2 }}>
          Loading functions...
        </Typography>
      </Stack>
    );
  }

  if (functions.length === 0) {
    return (
      <Stack alignItems="center" justifyContent="center" sx={{ py: 8 }}>
        <Typography level="body-md" color="neutral">
          No functions match your filters
        </Typography>
        <Typography level="body-sm" color="neutral" sx={{ mt: 1 }}>
          Try adjusting your search or filter criteria.
        </Typography>
      </Stack>
    );
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: 2,
        py: 1,
      }}
    >
      <AnimatePresence mode="popLayout">
        {functions.map((func, index) => (
          <motion.div
            key={func.id}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.2, delay: index * 0.02 }}
            layout
          >
            <FunctionCard
              func={func}
              status={getFunctionStatus(func)}
              isRunning={isRunning(func.id)}
              selected={selectedFunctionId === func.id}
              onRun={onRun}
              onEdit={onEdit}
              onDuplicate={onDuplicate}
              onDelete={onDelete}
              onViewLogs={onViewLogs}
              onSelect={onSelect}
            />
          </motion.div>
        ))}
      </AnimatePresence>
    </Box>
  );
};

export default FunctionsGrid;
